export default __webpack_public_path__ + "static/media/K2D-Light.fbe4650a.ttf";